import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    console.warn('Sentry DSN not configured. Error monitoring is disabled.')
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    _experiments: {
      enableLogs: true,
    },
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (import.meta.env.DEV) {
        console.log('[Sentry] Event captured:', event)
      }
      return event
    },
  })
}

export function setUserContext(user: {
  id: string
  email: string
  name?: string
  accountId?: string
  profile?: string
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
    accountId: user.accountId,
    profile: user.profile,
  } as Sentry.User & { accountId?: string; profile?: string })
}

export function clearUserContext() {
  Sentry.setUser(null)
}

export function captureError(error: Error, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context })
}

export function captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
  Sentry.captureMessage(message, level)
}

export { Sentry }
